// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

// because IE11 doesn't support dynamic columns
// via grid-auto-columns, we'll fallback to
// a flex approach which achieves basically the same thing
// but the button width is distributed based on flex and not fr.

// visually hides the radio element but leaves it still a11y compliant.
export const Input = styled.input`
  left: -999vw;
  position: fixed;
`

export const Label = styled.label`
  background-color: #555;
  border-left: 1px solid #000;
  box-shadow: inset 0 0 .125em .05em #ccc, inset .025em .025em .025em  #ccc;
  color: #fff;
  cursor: pointer;
  display: block;
  // heading-font
  font-family: refrigerator-deluxe, sans-serif;
  padding: .25em .5em;
  text-align: center;
  text-shadow: 0 0 transparent, .125em .125em .25em #000;
  transition-duration: .4s;
  transition-property: background-color, box-shadow;
  transition-timing-function: ease-out;
  user-select: none;

  -ms-flex: 1 0 auto;
  flex: 1 0 auto;

  @supports (grid-auto-columns: 1fr) {
    grid-row: 1;
  }

  &:first-of-type {
    border-left-width: 0;
  }

  input:checked + & {
    // same as $green in variables.scss
    background-color: #46b34e;
    box-shadow: inset 0 0 .125em .05em #000, inset 0 0 .125em #000;
    transition-duration: .2s;
    text-shadow: .02em .02em black, -.02em -.02em black;
  }

  input:checked:focus + & {
    text-decoration: underline;
  }

  input:disabled + & {
    cursor: not-allowed;
    opacity: .5;
  }
`

export const UpdatedRadioGroupWrapper = styled.div`
  border: 1px solid;
  border-radius: 4px;
  display: flex;
  margin: auto;
  overflow: hidden;

  @supports (grid-auto-columns: 1fr) {
    display: grid;
    grid-auto-columns: 1fr;
  }

  &.align-start {
    margin-left: 0;
  }

  &:focus-within {
    outline: 5px solid Highlight;
    outline-offset: -2px;

    @media (-webkit-min-device-pixel-ratio:0) {
      // webkit native focus
      outline-color: -webkit-focus-ring-color;
      outline-style: auto;
    }
  }
`
